import LoadingComponent from "../../../../../components/LoadingComponent.jsx";
import React, {useEffect, useState} from "react";
import useAuthorityConfiguration from "../../../../../api/utilities/useAuthorityConfiguration.js";
import {ErpCalculationApi} from "../../../../../api/authority/generated/index";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../../api/utilities/translateErrorMessage.js";
import toast from "react-hot-toast";
import SeeMore from "../../../../../components/SeeMore.jsx";
import {useTopChannelColumns} from "../../../topChannelColumns.js";
import useUserSettings from "../../../../../utils/useUserSettings.js";
import DataGrid2 from "../../../../../components/datagrid/DataGrid2.jsx";

export default function DailyTopChannelPerformance({title, day, project}) {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let columns = useTopChannelColumns(project, true);

    let [data, setData] = useState(null);
    let workerConfig = useAuthorityConfiguration();
    let dayKey = day.format('YYYY-MM-DD');

    let [userSettings] = useUserSettings();

    useEffect(() => {
        let active = true;
        setData(null);

        new ErpCalculationApi(workerConfig)
            .dailyTopChannelPerformance({
                projectId: project.id,
                dayInput: {
                    day: dayKey,
                }
            })
            .then((nextData) => {
                if (!active) {
                    return;
                }

                setData(nextData);
            })
            .catch(e => {
                if (!active) {
                    return;
                }

                et(e).then((message) => { if (message) toast.error(message); });
            });

        return () => {
            active = false;
        };
    }, [dayKey, project.id]);

    // noinspection JSUnresolvedReference
    return (
        <LoadingComponent
            loading={data === null}
            className={'col-span-12 sm:col-span-6 text-slate-600 dark:text-slate-400'}
        >
            <div
                className="comp__roundedBox inline-flex flex-col w-full rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700">
                <div
                    className={'px-5 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center'}>
                    <h2 className={'font-semibold text-slate-800 dark:text-slate-100'}>
                        {title}
                    </h2>
                </div>
                <div className={'p-3'}>
                    {<SeeMore heightClass={'h-32'} active={(data?.topChannels.length ?? 0) > 5}>
                        <DataGrid2
                            showHeader={true}
                            columns={columns}
                            dataSource={data?.topChannels}
                        />
                    </SeeMore>}
                </div>
            </div>
        </LoadingComponent>
    );
}
